export const moduleTranslation = (moduleName: string): string => {
	let moduleTranslation = "";
	if (moduleName.endsWith("Module")) {
		moduleTranslation = moduleName
			.substring(0, moduleName.length - 6)
			.toLowerCase();
	}

	return moduleTranslation;
};
